import { Button } from '@/components/ui/Button/Button';
import { DialogBody, DialogFooter } from '@/components/ui/Dialog/Dialog';
import { Illustration } from '@/components/ui/Illustration/Illustration';
import { captureAnalyticsEvent } from '@/lib/mixpanel';
import { useTranslation } from 'react-i18next';
import { useCancelFlow } from '../../../CancelDialog/context/useCancelFlow';
import { useRescheduleFlow } from '../../context/useRescheduleFlow';

export const LateRescheduleStep = () => {
  const { t } = useTranslation('scheduling', { keyPrefix: 'rescheduleDialog.steps.lateRescheduleStep' });

  const { closeRescheduleDialog, data, getOpenButtonRef } = useRescheduleFlow();
  const { openCancelDialog } = useCancelFlow();

  const handleCancel = () => {
    void captureAnalyticsEvent('rescheduling_late_cancel', { appointment_id: data.appointment?.appointment_id });
    closeRescheduleDialog();

    // Get the button ref that opened the reschedule dialog and pass it to cancel dialog
    const buttonRef = getOpenButtonRef();
    openCancelDialog(data.appointment!, buttonRef);
  };

  return (
    <>
      <DialogBody className='flex h-full flex-col items-center justify-center text-center'>
        <Illustration name='ruler' className='mb-6 size-28' />
        <div className='max-w-[320px] space-y-4'>
          <p className='text-heading-m-semibold'>{t('title')}</p>
          <p className='text-body-m-regular text-text-default-secondary'>{t('description')}</p>
        </div>
      </DialogBody>
      <DialogFooter withBorder={false}>
        <Button variant='text-secondary' className='w-full' onClick={() => closeRescheduleDialog()}>
          {t('closeButton.label')}
        </Button>
        <Button className='w-full' onClick={handleCancel}>
          {t('cancelButton.label')}
        </Button>
      </DialogFooter>
    </>
  );
};
